/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_BodyInputs */

const en_mcp_cap_library_body = /** @type {(inputs: Mcp_Cap_Library_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your agent for your latest documents or whether one is done, and get a link to play it.`)
};

const es_mcp_cap_library_body = /** @type {(inputs: Mcp_Cap_Library_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pide a tu agente tus documentos recientes o si uno ya está listo, y recibe un enlace para escucharlo.`)
};

/**
* | output |
* | --- |
* | "Ask your agent for your latest documents or whether one is done, and get a link to play it." |
*
* @param {Mcp_Cap_Library_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_body = /** @type {((inputs?: Mcp_Cap_Library_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_body(inputs)
	return en_mcp_cap_library_body(inputs)
});